import * as Yup from "yup";
import { UserQuestionnaireType } from "../helper/constants";

const MIN_NAME_LENGTH: number = 5;
const MAX_NAME_LENGTH: number = 100;

const AddQuestionnaireValidator = Yup.object({
    name : Yup.string()
        .required("Name is Required")
        .trim()
        .min(
            MIN_NAME_LENGTH,
            `Name must be at least ${MIN_NAME_LENGTH} characters long`
        )
        .max(
            MAX_NAME_LENGTH,
            `Name must be less than ${MAX_NAME_LENGTH} characters long`
        ),
    type : Yup.number()
        .required("Type is Required"),
    startDate : Yup.string()
        .test(
            "is-start-date-empty",
            "Start Date is Required",
            function (value) {
                const { type } = this.parent;
                if(Number(type) === UserQuestionnaireType.SCHEDULED && value === undefined ) {
                    return false;
                }

                return true;
            }
        ),
    endDate : Yup.string()
            .test(
                "is-start-date-empty",
                "End Date is Required",
                function (value) {
                    const { type } = this.parent;
                    if(Number(type) === UserQuestionnaireType.SCHEDULED && value === undefined ) {
                        return false;
                    }

                    return true;
                }
            )
            .test(
                "is-endDate-after-startDate",
                "End Date must be greater than Start Date",
                function (value) {
                    const { startDate } = this.parent;
                    
                    if (!startDate || !value) {
                        return true; // Skip validation if either date is not provided
                    }
                    const start = new Date(startDate);
                    const end = new Date(value);
                    return end > start;
                }
            ),

    
});
export default AddQuestionnaireValidator;